import EndScreen from './scenes/EndScreen';
import GameScreen from './scenes/GameScreen';
import IntroScreen from './scenes/IntroScreen';

export const GameVersions = {
  Number: 'number',
  Shape: 'shape'
};

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [IntroScreen, GameScreen, EndScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY,

  gameVersion: GameVersions.Number,
  gameMode: 'race', // practice or race
};

export const GAME_IMAGES_KEY = 'gameuiassets';
export const GAME_IMAGES_JSON_PATH = 'assets/images/GameUIAssets.json';
export const GAME_IMAGE_BASE_PATH = 'assets/images/';
